/* @ngInject */
function AuthenticationInterceptor($injector) {
  return {
    request: function (config) {
      const SecurityManager = $injector.get("SecurityManager");

      // Si no estoy haciendo una peticion a mi servidor no meter el token.
      if (config.url.indexOf(process.env.SERVER_URL) === -1) {
        return config;
      }

      if (!SecurityManager.isAuthenticated()) return config;

      config.headers.Authorization =
        "Bearer " + SecurityManager.getAccessToken().token;

      return config;
    },
  };
}

export default AuthenticationInterceptor;
